/**
 * 云平台appId固定值
 */
const APP_ID = 116;

const InitState = {
  tokenInfo: null,
  userInfo: null
};

const HttpResponseCode = {
  USER_BIND_HAS_NOT: 6006, // 用户绑定身份信息为空
  USER_ROLE_HAS_NOT: 6007, // 选择用户身份
  CLOUD_SCHOOL_HAS_NOT: 6009, // 学校未开通
  USER_STATUS_DISABLED: 6010, // 学校未开通
  PERMISSION_DENIED: 6012, // 用户身份没有权限
  CLOUD_FUNCTION_HAS_NOT: 6013, // 云功能未开通
  CLOUD_FUNCTION_DISABLED: 6014, // 云功能已停用
  CLOUD_FUNCTION_EXPIRED: 6015, // 云功能已到期
  USER_IN_SECURITY_BLACKLIST: 6016, // 用户ssoid在黑名单
  USER_HAS_LOGGED_OUT: 6017, // 用户已登出
};

/**
 * 权限类型
 * 参见 {@link https://confluence.unipus.cn/pages/viewpage.action?pageId=41370300}
 */
const PermissionType = {
  DIRECTORY: 1, // 目录
  Function: 2, // 功能：按钮/权限
}

/**
 * 存储 token 相关信息
 */
const TOKEN_KEY = '__token';

/**
 * 存储 ssologin 跳转前页面地址
 */
const SERVICE_KEY = '__service';

/**
 * ID Token 过期前多久刷新
 */
const REFRESH_EARLY_TIME = 5 * 60 * 1000;

export {
  APP_ID,
  InitState,
  HttpResponseCode,
  PermissionType,
  TOKEN_KEY,
  SERVICE_KEY,
  REFRESH_EARLY_TIME,
};